import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import {Link, useLocation} from "react-router-dom";
import useData from "../../../hooks/useData";
import {
    getBillingLastMonthList,
    getBillingMonthList,
    mailBillingMonth,
    printBillingMonth
} from "../../../api/admin/billingReq";
import {useEffect, useRef, useState} from "react";
import useAuth from "../../../hooks/useAuth";
import BillingDetails from "./BillingDetails";
import ViewBillingInfos from "./ViewBillingInfos";
import FormNewBilling from "../../../forms/admin/billing/FormNewBilling";
import FormBillingSearch from "../../../forms/admin/billing/FormBillingSearch";

export default function Billing({tab}) {
    const { auth } = useAuth();
    const token = auth.token;
    const location = useLocation();
    const { billingMonthList, setBillingMonthList, setBillingLastMonthList} = useData();
    const [ dataId, setDataId ] = useState(0);
    const [ month, setMonth ] = useState();
    const [ showModalNewBillings, setShowModalNewBillings ] = useState(false);
    const [ showModalSearchBilling, setShowModalSearchBilling ] = useState(false);
    const handleChangeDataId = (id, month) => {
        setDataId(id);
        setMonth(month)
    }


    const apiMonthList = async () => {
        const response = await getBillingMonthList(token);
        setBillingMonthList(response);
    }

    const apiLastMonthList = async () => {
        const response = await getBillingLastMonthList(token);
        setBillingLastMonthList(response);
    }

    useEffect(() => {
        apiMonthList();
    }, [ token ]);
    useEffect(() => {
        apiLastMonthList();
    }, [ token ]);

    useEffect(() => {
        if (location.state?.openSearch) {
            setShowModalSearchBilling(true);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    const handleNewBillForm = () => {
        setShowModalNewBillings(true)
    }

    const handleSearchBilling = () => {
        setShowModalSearchBilling(true)
    }

    const handleMailAll = (e) => {
        e.preventDefault()
        let body = {
            monthId: dataId,
        }
        mailBillingMonth(token, body)
    }

    const handlePrintAll = (e) => {
        e.preventDefault()
        let body = {
            monthId: dataId,
        }
        printBillingMonth(token, body)
            .then(response => {
                const pdfUrl = response?.pdfUrl;
                if (!pdfUrl) {
                    return;
                }
                const pdfLink = document.createElement('a');
                pdfLink.href = pdfUrl;
                pdfLink.target = '_blank';
                pdfLink.setAttribute('download', `Factures-${month}.pdf`);
                document.body.appendChild(pdfLink);
                pdfLink.click();
                document.body.removeChild(pdfLink);
            })
    }

    const tabSources = "fa fa-bars"

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Facturation"
                slug="/admin/accueil"
            />
            { showModalNewBillings &&
                <div className="modal billing">
                    <FormNewBilling apiBilling={apiMonthList} setShowNewBillings={setShowModalNewBillings}/>
                </div>
            }
            { showModalSearchBilling &&
                <div className="modal billing-search">
                    <FormBillingSearch setShowModalSearchBilling={setShowModalSearchBilling} />
                </div>
            }
            <nav className="tabs-menu">
                <ul>
                    <li className="active"><Link to="">Forfait</Link></li>
                    <li><Link to="">Défunt</Link></li>
                    <li><Link to="parametres">Paramètres</Link></li>
                </ul>
            </nav>
                <div className="content-container cms-top">
                    <Icon source="fa fa-file-invoice-dollar" span="Facturation" />
                    <div className="cms-button">
                        <button onClick={handleNewBillForm}><i className="fa fa-plus"></i><span>Ajouter</span></button>
                        <button onClick={handleSearchBilling}><i className="fa fa-search"></i><span>Rechercher</span></button>
                        {dataId != 0 &&
                            <>
                                <button className="green-button" onClick={handleMailAll}><i className="fa fa-paper-plane"></i><span>Toutes les factures</span></button>
                                <button className="green-button" onClick={handlePrintAll}><i className="fa fa-print"></i><span>Toutes les factures</span></button>
                            </>
                        }
                    </div>
            <div className="double-fieldset">
                    <fieldset className="dashboard month-date">
                        <div className="dashboard">
                            <table className="facturation">
                                <thead>
                                <tr>
                                    <th>Mois</th>
                                    <th>Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                {billingMonthList?.map((data, index) => (
                                    <tr key={index} className={dataId === data.id ? "selected" : ""}
                                        onClick={() => handleChangeDataId(data?.id, data?.month)}>
                                        <td>{data?.month}</td>
                                        <td>{data?.date}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>

                    </fieldset>
                    <fieldset className="dashboard facturation-detail">
                        {month && <legend>{month}</legend>}
                        {dataId === 0 ?
                            <div className="select-month-placeholder">
                                <i className="fa fa-file-invoice-dollar"/>
                                <span>Sélectionnez un mois</span>
                            </div>
                            :
                            <>
                                {tab === "Détails de facturation" &&
                                    <BillingDetails dataId={dataId} month={month} location="Détail du mois de facturation"/>
                                }
                                {tab === "Détail d'une facture" &&
                                    <ViewBillingInfos/>
                                }
                            </>
                        }
                    </fieldset>
                </div>
            </div>
        </main>
    )
}